import { FC, ReactNode } from "react"
import { ProtectedRoute } from "../components/core/protected/ProtectedRoute"
import { RootLayout } from "../components/layout/RootLayout"

/**
 * Higher-Order Component that combines authentication protection with role-based access control
 * and wraps it in the RootLayout
 * @param RoleProtectedRoute The role-specific protection component
 * @returns A component with authentication and role protection applied
 */
export const withRoleProtection = (RoleProtectedRoute: FC<{children: ReactNode}>) => {
  const ProtectedRouteElement = () => (
    <ProtectedRoute>
      <RoleProtectedRoute>
        <RootLayout />
      </RoleProtectedRoute>
    </ProtectedRoute>
  )
  return <ProtectedRouteElement />
} 